import { render, staticRenderFns } from "./RecentlyAddedSidebar.vue?vue&type=template&id=3993ca80&scoped=true&"
import script from "./RecentlyAddedSidebar.vue?vue&type=script&lang=ts&"
export * from "./RecentlyAddedSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./RecentlyAddedSidebar.vue?vue&type=style&index=0&id=3993ca80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3993ca80",
  null
  
)

export default component.exports